exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".el-timeline{margin:0;font-size:14px;list-style:none}.el-timeline .el-timeline-item:last-child .el-timeline-item__tail{display:none}\n", "", {"version":3,"sources":["/var/lib/jenkins/workspace/tms-docker-build/frontend/shipper/src/element-theme-chalk/lib/timeline.css"],"names":[],"mappings":"AAAA,aAAa,SAAS,eAAe,eAAe,CAAC,kEAAkE,YAAY,CAAC","file":"timeline.css","sourcesContent":[".el-timeline{margin:0;font-size:14px;list-style:none}.el-timeline .el-timeline-item:last-child .el-timeline-item__tail{display:none}\n"],"sourceRoot":""}]);

// exports
